import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { ShareEmailDocument } from './ShareEmailDocument';
import UserProvider from 'providers/UserProvider';
import { ApiUserRepository } from 'services/repositories/implementations/ApiUserRepository';
import { useTranslation } from 'react-i18next';
import Close from '@mui/icons-material/Close';
import { useContentMetadata } from 'components/editor/hooks/useContentMetadata';
import { ContentType } from 'utils/getContentType';

type DocumentShareDocumentProps = {
  contentId: string;
  documentTitleWithCompanyName: string;
  isOpen: boolean;
  onResolve: () => void;
  onSuccess: () => void;
};

export const DocumentShareDialog = ({
  contentId,
  documentTitleWithCompanyName,
  isOpen,
  onResolve,
  onSuccess,
}: DocumentShareDocumentProps) => {
  const { t } = useTranslation();

  const { refetch: refetchDocument } = useContentMetadata(ContentType.DOCUMENT, contentId);

  return (
    <UserProvider userRepository={new ApiUserRepository()}>
      <Dialog
        open={isOpen}
        onClose={onResolve}
        PaperProps={{ sx: { borderRadius: 3, width: 1024, maxWidth: '100%', padding: 3 } }}
        className="document-share-modal"
      >
        <DialogTitle sx={{ padding: '0 !important', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          {t('share_document_v3.email_share_modal.title', { documentName: documentTitleWithCompanyName })}
          <IconButton onClick={onResolve}>
            <Close />
          </IconButton>
        </DialogTitle>
        <ShareEmailDocument
          contentId={contentId}
          onSuccess={() => {
            refetchDocument();
            onSuccess();
          }}
        />
      </Dialog>
    </UserProvider>
  );
};
